import React, { useContext } from "react";
import { Context } from "../../../Context";
import hash from "object-hash";
import { ProfileView } from "../../views/index";
import { ValidateInputPure } from "../../pures";
import {
  LocalStorageService,
  PlanService,
  UserService,
  UserDocService,
  AddressService,
  DownloadSignaturesService,
  UserDocSuppService,
  BovedaApi,
} from "../../../services";
import { ProfileValidator } from "../../../validators";
import { useTranslation } from "react-i18next";
import initialState from "../../../utils/initialState";
import ChangePasswordAction from "../change-password/change-password.action";
import moment from "moment";
import "moment/locale/es";
import { formatPhoneNumber } from 'react-phone-number-input'

class ProfileAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      donwloadSignatureScreen: false,
      changePasswordScreen: false,
      userFullName: "",
      rfc: "",
      curp: "",
      userPhone: "",
      userPathImage: "",
      userImage: "",
      userMail: "",
      userFullDirection: "",
      planName: "",
      signsAvailable: "",
      totalSigns: "",
      expirationDate: "",
      monthlyTransactions: "",
      pricing: "",
      visible: false,
      userInEdit: undefined,
      visibleDialogUpdate: false,
      userId: "",
      userTypeId: "",
      languageId: "",
      clientId: "",
      addressId: "",
      firstName: "",
      firstLastName: "",
      secondLastName: "",
      phoneNumber: "",
      cellphoneNumber: "",
      email: "",
      street: "",
      internalNumber: "",
      externalNumber: "",
      colony: "",
      township: "",
      state: "",
      country: "",
      zipCode: "",
      organization: "",
      personTypeId: "",
      errorFirstName: false,
      errorFirstLastName: false,
      errorSecondLastName: false,
      errorPhoneNumber: false,
      errorRFC: false,
      errorCURP: false,
      errorStreet: false,
      errorInternalNumber: false,
      errorExternalNumber: false,
      errorColony: false,
      errorZipCode: false,
      errorTownship: false,
      errorState: false,
      errorCountry: false,
      errorVerifyForm: false,
      showNotification: false,
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      contractPlanExist: true,
      downloadLoading: false,
      downloadError: false,
      isLoadingUserDocSupp: false,
      errorUserDocSupp: null,
      errorWarningDoc: null,
      signatureImg: null,
      ineFrontImg: null,
      ineBackImg: null,
      downloadSuccess: false,
      saveImagesSuccess: false,
      downloadErrorMessage: false,
    };

    this.toggleDialogUpdateUserAddress =
      this.toggleDialogUpdateUserAddress.bind(this);
    this.toggleDialogProfile = this.toggleDialogProfile.bind(this);
    this.onDeleteDataProfile = this.onDeleteDataProfile.bind(this);
  }

  notification = {
    type: {
      style: "error",
      icon: true,
    },
    style: {
      bottom: 55,
      right: 30,
      position: "fixed",
    },
  };

  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  planService = new PlanService(this.url);
  userDocService = new UserDocService(this.url);
  userService = new UserService(this.url);
  addressService = new AddressService(this.url);
  userDocSuppService = new UserDocSuppService(this.url);
  downloadSignaturesService = new DownloadSignaturesService(this.url);
  validator = ProfileValidator(this.props.t);
  bovedaApi = new BovedaApi(process.env.REACT_APP_MIFIRMA_API);

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    this.newImage = this.localStorageService.getLocalStorageItem("newImage");
    let userInformation = this.user.userMetaData.userA3Cloud;
    let userInformationAkubicaFirmaDigital = this.user.userMetaData.userMifirma;

    let phoneValue;
    userInformation.phoneNumber === null ||
      userInformation.phoneNumber.trim() === ""
      ? (phoneValue = "")
      : (phoneValue = userInformation.phoneNumber);
    let phone = `${phoneValue}`;
    let { countryCodeCellphone, countryCodePhone } = userInformation;
    let fullName = `${userInformation.firstName} ${userInformation.firstLastName} ${userInformation.secondLastName}`;
    let mail = `${userInformation.email}`;
    let image;
    this.newImage
      ? (image = this.newImage)
      : userInformation.profilePicture
        ? (image = userInformation.profilePicture)
        : (image = this.user.userMetaData.userAuth0.picture);
    let pathImage = `${image}`;
    let address = userInformation.address || {};
    let userAddress = "--------";
    if (
      address?.street &&
      address?.street !== null &&
      address?.street !== " " &&
      address?.colony &&
      address?.colony !== null &&
      address?.colony !== " " &&
      address?.township &&
      address?.township !== null &&
      address?.township !== " " &&
      address?.state &&
      address?.state !== null &&
      address?.state !== " " &&
      address?.zipCode &&
      address?.zipCode !== null &&
      address?.zipCode !== " " &&
      address?.country &&
      address?.country !== null &&
      address?.country !== " "
    ) {
      userAddress = `${address?.street ?? ""}, Col. ${address?.colony ?? ""}, ${address?.township ?? ""
        }, ${address?.state ?? ""}, C.P. ${address?.zipCode ?? ""}`;
    }
    let data = {};
    try {
      let imgs = await this.userDocSuppService.getUserDocSupps(this.token);
      if (imgs) {
        let { autographySignImg, ineFrontImg, ineBackImg } = imgs;
        data = {
          signatureImg: "data:image/png;base64," + autographySignImg,
          ineFrontImg: "data:image/png;base64," + ineFrontImg,
          ineBackImg: "data:image/png;base64," + ineBackImg,
        };
      }
    } catch (error) {
      data = { signatureImg: null, ineFrontImg: null, ineBackImg: null };
    }
    try {
      this.setState({
        userFullName: fullName,
        userPhone: phone,
        cellphoneNumber: countryCodeCellphone,
        phoneNumber: countryCodePhone,
        userPathImage: pathImage,
        userMail: mail,
        userFullDirection: userAddress,
        userId: userInformation.id,
        userTypeId: userInformationAkubicaFirmaDigital.userType.id,
        languageId: userInformationAkubicaFirmaDigital.language.id,
        clientId: userInformation.clientId,
        rfc: userInformation.rfc,
        curp: userInformation.curp,
        addressId: userInformation.address.id,
        personTypeId: userInformation.client.personTypeId,
        organization: userInformation.client.organization,
        firstName: userInformation.firstName,
        lastName: ` ${userInformation.firstLastName} ${userInformation.secondLastName}`,
        ...data,
      });
    } catch (error) {
      this.props.history.push("/");
      this.props.setShowError(true);
      return;
    }
    let userContractPlan = initialState["planService.getUserContractAndPlan"];
    if (!userContractPlan) {
      userContractPlan = await this.planService.getUserContractAndPlan(
        this.token
      );
      initialState["planService.getUserContractAndPlan"] = userContractPlan;
    }
    this.setState({
      loading: false,
    });
    if (userContractPlan.data) {
      moment.locale("es");
      let dateExpiration =
        userContractPlan.data.contract.endOfContract.split("T")[0];
      try {
        if (userContractPlan.statusCode && userContractPlan.statusCode === -1) {
          this.setState({
            contractPlanExist: false,
          });
        } else {
          this.setState({
            planName: userContractPlan.data.plan.name,
            signsAvailable: userContractPlan.data.contract.availableTransaction,
            totalSigns: userContractPlan.data.contract.annualTransaction,
            expirationDate: moment(dateExpiration).format("DD/MMMM/YYYY"),
            monthlyTransactions:
              userContractPlan.data.contract.monthlyTransaction,
            pricing: userContractPlan.data.contract.pricing,
            contractPlanExist: true,
          });
        }
      } catch (error) {
        this.props.history.push("/");
        this.props.setShowError(true);
      }
    } else {
      this.setState({
        contractPlanExist: false,
      });
    }
  }

  fetchDowloadSignatures = async () => {
    try {
      let result = await this.downloadSignaturesService.getCurrentSignatures(
        this.token
      );
      if (!result || result === null) {
        this.toggleErrorRequesting(true);
      }
      let { filePrivateKey, fileCertificate, filePublicKey } = result;
      let files = [
        {
          file: new Uint8Array(filePrivateKey.data.data),
          name: filePrivateKey.name,
        },
        {
          file: new Uint8Array(fileCertificate.data.data),
          name: fileCertificate.name,
        },
        {
          file: new Uint8Array(filePublicKey.data.data),
          name: filePublicKey.name,
        },
      ];
      files.forEach((item) => {
        let blob = new Blob([item.file], { type: "application/octet-binary" });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = item.name;
        link.click();
      });
      await this.downloadSignaturesService
        .putUserKeys(this.token)
        .then((result) => {
          this.setState({ donwloadSignatureScreen: false }, () => {
            this.setState({ downloadSuccess: true }, () =>
              setTimeout(() => {
                this.setState({
                  downloadLoading: false,
                  downloadErrorMessage: null,
                  downloadSuccess: false,
                });
                // setVisibleSignatureReliable(false)
              }, 1000)
            );
          });
          this.props.onRegisterEnd(this.state.contract);
        })
        .catch((error) => {
          this.setState(
            {
              downloadLoading: false,
              showCompletedRequesting: false,
              showErrorRequesting: false,
              showLoadingRequesting: false,
              downloadErrorMessage: true,
            },
            () =>
              setTimeout(() => {
                this.setState({ downloadErrorMessage: false });
              }, 3000)
          );
        });
    } catch (error) {
      this.setState(
        {
          downloadLoading: false,
          showCompletedRequesting: false,
          showErrorRequesting: false,
          showLoadingRequesting: false,
          downloadErrorMessage: true,
        },
        () =>
          setTimeout(() => {
            this.setState({ downloadErrorMessage: false });
          }, 3000)
      );
    }
  };

  /* ============= START Dialog ================ */
  toggleDialogUpdateUserAddress = () => {
    this.setState({ visibleDialogUpdate: !this.state.visibleDialogUpdate });

    // Cargar datos del Edit en el state
    this.user = this.localStorageService.getLocalStorageItem("user");
    let userInformation = this.user.userMetaData.userA3Cloud;
    let address = userInformation.address;

    let phone = this.state.phoneNumber ? this.state.phoneNumber : "";
    let externalNumberValue = address.externalNumber
      ? address.externalNumber
      : "";
    let cellPhone = this.state.cellphoneNumber
      ? this.state.cellphoneNumber
      : "";

    this.setState({
      firstName: userInformation.firstName,
      firstLastName: userInformation.firstLastName,
      secondLastName: userInformation.secondLastName,
      phoneNumber: phone,
      cellphoneNumber: cellPhone,
      email: userInformation.email,
      street: address.street,
      internalNumber: address.internalNumber,
      externalNumber: externalNumberValue,
      colony: address.colony,
      township: address.township,
      state: address.state,
      country: address.country,
      zipCode: address.zipCode,
    });

    if (this.state.visibleDialogUpdate === true) {
      this.cleanErrors();
    }
  };
  /**
   * @author Lucia Alvarado
   * @description Show dialog edit profile
   * @memberof ProfileAction
   */
  handleEditProfile = () => {
    this.setState({
      visible: !this.state.visible,
    });
  };

  /**
   * @author Lucia Alvarado
   * @description Show dialog
   * @memberof ProfileAction
   */
  toggleDialogProfile() {
    this.setState({
      visible: !this.state.visible,
    });
  }

  /**
   * @author Alan Aguilar
   * @description Method Delete the profile data from the state
   * @param {Event} event
   * @memberof ProfileAction
   */
  onDeleteDataProfile() {
    this.setState({
      visible: false,
      dataItem: {},
    });
    this.clearErrors();
  }

  onCloseOpenModal = () => {
    this.setState({ showNotification: false });
  };

  handleMessage = () => {
    this.setState(
      {
        showNotification: true,
      },
      () => {
        setTimeout(() => {
          this.onCloseOpenModal();
        }, 5000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the loading dialog modal
   * @memberof ProfileAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the confirmed sign dialog modal and redirecto to home
   * @memberof ProfileAction
   */
  toggleCompletedRequesting = (value) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            showLoadingRequesting: false,
          });
          // window.location.reload();
        }, 4000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Method to show the error dialog modal
   * @memberof ProfileAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 6000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description handle change to update the states of the dialog form Edit
   * @param {Object} dataItem
   * @memberof ProfileAction
   */
  handleChangeGeneral = async (event) => {
    this.setState({
      ...this.state,
      [event.target.props.id]: event.target.value,
    });
  };

  /**
 * @author Adrian Montemayor
 * @description handle change to update the states of PhoneNumber
 * @param {Object} dataItem
 * @memberof ProfileAction
 */
  handleChangePhone = async (phoneNumber) => {
    this.setState({
      phoneNumber: phoneNumber
    });
  };

  /**
* @author Adrian Montemayor
* @description handle change to update the states of PhoneNumber
* @param {Object} dataItem
* @memberof ProfileAction
*/
  handleChangeCellPhone = async (phoneNumber) => {
    this.setState({
      cellphoneNumber: phoneNumber
    });
  };

  /**
   * @author Adrian Montemayor
   * @description handle change to update the image of profile.
   * @param {Object} dataItem
   * @memberof ProfileAction
   */
  handleImage = async (e) => {
    if (e.target.files && e.target.files[0]) {
      if (e.target.files[0].size < 4194304) {
        let reader = new FileReader();
        reader.onload = async (e) => {
          this.setState({
            userPathImage: e.target.result,
          });
          await this.localStorageService.setLocalStorageItem(
            "newImage",
            e.target.result
          );
        };
        reader.readAsDataURL(e.target.files[0]);
        this.setState({
          userImage: e.target.files[0],
        });
        let updateFile = new FormData();
        updateFile.append("file", e.target.files[0]);
        await this.userDocService.getUserDocProfile(updateFile, this.token);
      } else {
        this.setState(
          {
            showErrorRequesting: true,
            message: this.props.t("dialogUpdateUserAddress.ImageError"),
          },
          () => {
            setTimeout(() => {
              this.setState({ showErrorRequesting: false });
            }, 4000);
          }
        );
      }
    }
  };

  /**
   * @author Alan Aguilar
   * @description Clean the hint errors of the dialog
   * @param {Object} dataItem
   * @memberof ProfileAction
   */
  cleanErrors = () => {
    this.setState({
      errorFirstName: false,
      errorFirstLastName: false,
      errorSecondLastName: false,
      errorPhoneNumber: false,
      errorRFC: false,
      errorStreet: false,
      errorInternalNumber: false,
      errorExternalNumber: false,
      errorColony: false,
      errorZipCode: false,
      errorTownship: false,
      errorState: false,
      errorCountry: false,
      errorVerifyForm: false,
      errorCURP: false,
    });
  };

  /**
   * @author Alan Aguilar
   * @description Show dialog confirm
   * @param {Object} dataItem
   * @memberof ProfileAction
   */
  onSubmitUpdateUserAddress = async (e) => {
    e.preventDefault();
    this.cleanErrors();
    try {
      this.token =
        this.localStorageService.getLocalStorageItem("token").idToken;

      let {
        firstName,
        firstLastName,
        secondLastName,
        phoneNumber,
        cellphoneNumber,
        street,
        internalNumber,
        externalNumber,
        colony,
        township,
        state,
        country,
        zipCode,
        userTypeId,
        languageId,
        clientId,
        addressId,
        rfc,
        curp,
      } = this.state;

      // Deleting white spaces
      firstName = firstName ? firstName.trim() : "";
      firstLastName = firstLastName ? firstLastName.trim() : "";
      secondLastName = secondLastName ? secondLastName.trim() : "";
      phoneNumber = phoneNumber ? phoneNumber.trim() : "";
      cellphoneNumber = cellphoneNumber ? cellphoneNumber.trim() : "";
      street = street ? street.trim() : "";
      internalNumber = internalNumber ? internalNumber.trim() : "";
      externalNumber = externalNumber ? externalNumber.trim() : "";
      colony = colony ? colony.trim() : "";
      township = township ? township.trim() : "";
      state = state ? state.trim() : "";
      country = country ? country.trim() : "";
      zipCode = zipCode ? zipCode.trim() : "";
      rfc = rfc ? rfc.trim() : "";
      curp = curp ? curp.trim() : "";

      // Validate firstName
      let firstNameValid = this.validator.nameValidator(firstName);
      let eventId = hash({ hash: Math.random().toString(36).substring(7) });

      if (
        firstName === undefined ||
        firstName === "" ||
        firstNameValid !== ""
      ) {
        this.setState({ errorFirstName: true, errorVerifyForm: true });
        return false;
      }

      // Validate firsLasttName
      let firstLastNameValid =
        this.validator.firstLastNameValidator(firstLastName);
      if (
        firstLastName === undefined ||
        firstLastName === "" ||
        firstLastNameValid !== ""
      ) {
        this.setState({ errorFirstLastName: true, errorVerifyForm: true });
        return false;
      }

      // Validate secondLastName
      let secondLastNameValid =
        this.validator.secondLastNameValidator(secondLastName);
      if (
        secondLastName === undefined ||
        secondLastName === "" ||
        secondLastNameValid !== ""
      ) {
        this.setState({ errorSecondLastName: true, errorVerifyForm: true });
        return false;
      }

      // Validate phoneNumber
      let phoneNumberValid =
        this.validator.phoneNumberValidator(cellphoneNumber);
      if (
        cellphoneNumber === undefined ||
        cellphoneNumber === "" ||
        phoneNumberValid !== ""
      ) {
        this.setState({ errorPhoneNumber: true, errorVerifyForm: true });
        return false;
      }

      // Validate RFC
      if (rfc !== "") {
        let rfcValid = this.validator.rfcValidator(rfc);
        if (rfc === undefined || rfcValid !== "") {
          this.setState({ errorRFC: true, errorVerifyForm: true });
          return false;
        }
      } else {
        rfc = rfc.length <= 0 ? " " : rfc;
      }

      // Validate CURP
      if (curp !== "") {
        let curpValid = this.validator.curpValidator(curp);
        if (curp === undefined || curp === "" || curpValid !== "") {
          this.setState({ errorCURP: true, errorVerifyForm: true });
          return false;
        }
      } else {
        curp = curp.length <= 0 ? " " : curp;
      }

      // Validate street
      street = street.length <= 0 ? " " : street;
      let streetValid = this.validator.streetValidator(street);
      if (
        Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) === userTypeId
      ) {
        if (street === undefined || streetValid !== "") {
          this.setState({ errorStreet: true, errorVerifyForm: true });
          return false;
        }
      }

      // Validate colony
      colony = colony.length <= 0 ? " " : colony;
      let colonyValid = this.validator.colonyValidator(colony);
      if (
        Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) === userTypeId
      ) {
        if (colony === undefined || colonyValid !== "") {
          this.setState({ errorColony: true, errorVerifyForm: true });
          return false;
        }
      }

      // Validate zipCode
      zipCode = zipCode.length <= 0 ? "00000" : zipCode;
      let zipCodeValid = this.validator.zipCodeValidator(zipCode);
      if (
        Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) === userTypeId
      ) {
        if (
          (zipCode === undefined && zipCode !== "00000") ||
          zipCodeValid !== ""
        ) {
          this.setState({ errorZipCode: true, errorVerifyForm: true });
          return false;
        }
      }

      // Validate township
      township = township.length <= 0 ? " " : township;
      let townshipValid = this.validator.townValidator(township);
      if (
        Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) === userTypeId
      ) {
        if (township === undefined || townshipValid !== "") {
          this.setState({ errorTownship: true, errorVerifyForm: true });
          return false;
        }
      }

      // Validate state
      state = state.length <= 0 ? " " : state;
      let stateValid = this.validator.stateValidator(state);
      if (
        Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) === userTypeId
      ) {
        if (state === undefined || stateValid !== "") {
          this.setState({ errorState: true, errorVerifyForm: true });
          return false;
        }
      }

      // Validate country
      country = country.length <= 0 ? " " : country;
      let countryValid = this.validator.countryValidator(country);
      if (
        Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR) === userTypeId
      ) {
        if (country === undefined || countryValid !== "") {
          this.setState({ errorCountry: true, errorVerifyForm: true });
          return false;
        }
      }

      await this.toggleLoadingRequesting(true);

      let newCellPhoneNumber = formatPhoneNumber(this.state.cellphoneNumber)
      let newPhoneNumber = formatPhoneNumber(this.state.phoneNumber)

      let userData = {
        eventId,
        firstName,
        clientId,
        addressId,
        firstLastName,
        secondLastName,
        phoneNumber: newPhoneNumber,
        cellphoneNumber: newCellPhoneNumber,
        countryCodePhone: phoneNumber,
        countryCodeCellphone: cellphoneNumber,
        userTypeId,
        languageId,
        rfc,
        curp,
        termnsAndConditions: true,
      };
      let errors = [];
      let updateData = {};
      await this.userService
        .updateUser(userData, this.token)
        .then((result) => {
          let {
            cellphoneNumber,
            firstName,
            firstLastName,
            secondLastName,
            phoneNumber,
            email,
            rfc,
            curp,
          } = result.data.userA3CloudUpdate.data;
          updateData = {
            ...updateData,
            cellphoneNumber,
            firstName,
            firstLastName,
            secondLastName,
            phoneNumber,
            email,
          };
          let userFullName = `${firstName} ${firstLastName} ${secondLastName}`;
          this.setState({
            userFullName,
            userMail: email,
            rfc,
            curp,
          });
        })
        .catch((error) => errors.push(error));
      // let bovedaToken =
      //   this.localStorageService.getLocalStorageItem("bovedaToken");

      // if (bovedaToken && bovedaToken !== "") {
      //   try {
      //     let updateUserDocs = await this.bovedaApi.updateUserDocsPi(
      //       updateData.email,
      //       firstName,
      //       firstLastName,
      //       secondLastName,
      //       this.token
      //     );
      //   } catch (error) {
      //     console.log(error);
      //   }
      // }

      await this.addressService
        .updateAddress(
          addressId,
          street,
          internalNumber,
          externalNumber,
          colony,
          township,
          state,
          country,
          zipCode,
          this.token
        )
        .then((result) => {
          let res = result.data.data;
          let addressUpdateData = {};
          addressUpdateData.street = res.street;
          addressUpdateData.externalNumberValue = res.externalNumberValue;
          addressUpdateData.colony = res.colony;
          addressUpdateData.internalNumber = res.internalNumber;
          addressUpdateData.zipCode = res.zipCode;
          addressUpdateData.township = res.township;
          addressUpdateData.state = res.state;
          addressUpdateData.country = res.country;
          updateData.addressUpdateData = addressUpdateData;
          let userFullDirection = "--------";
          if (
            res?.street &&
            res?.street !== null &&
            res?.street !== " " &&
            res?.colony &&
            res?.colony !== null &&
            res?.colony !== " " &&
            res?.township &&
            res?.township !== null &&
            res?.township !== " " &&
            res?.state &&
            res?.state !== null &&
            res?.state !== " " &&
            res?.zipCode &&
            res?.zipCode !== null &&
            res?.zipCode !== " " &&
            res?.country &&
            res?.country !== null &&
            res?.country !== " "
          ) {
            userFullDirection = `${res?.street ?? ""}, Col. ${res?.colony ?? ""
              }, ${res?.township ?? ""}, ${res?.state ?? ""}, C.P. ${res?.zipCode ?? ""
              }`;
          }
          this.setState({ userFullDirection });
        })
        .catch((error) => errors.push(error));
      let localUserData = {
        ...this.localStorageService.getLocalStorageItem("user"),
      };
      localUserData.userMetaData.userA3Cloud = {
        ...localUserData.userMetaData.userA3Cloud,
        ...updateData,
      };
      localUserData.userMetaData.userA3Cloud.address = {
        ...localUserData.userMetaData.userA3Cloud.address,
        ...updateData.addressUpdateData,
      };
      this.localStorageService.setLocalStorageItem("user", localUserData);
      await this.toggleLoadingRequesting(false);
      await this.toggleCompletedRequesting(true);
      this.setState({ visibleDialogUpdate: false });
    } catch (error) {
      return false;
    }
  };

  /**
   * @author Adrian Montemayor
   * @description Save User data when redirecting to register onboarding
   * @memberof ProfileAction
   */
  onInvitedExistRedirectRegister = async () => {
    this.user = this.localStorageService.getLocalStorageItem("user");
    let userInformation = this.user.userMetaData.userA3Cloud;

    let phone = this.state.phoneNumber ? this.state.phoneNumber : "";
    let cellPhone = this.state.cellphoneNumber
      ? this.state.cellphoneNumber
      : "";

    let userCapturedInformation = {
      firstName: userInformation.firstName,
      firstLastName: userInformation.firstLastName,
      secondLastName: userInformation.secondLastName,
      phoneNumber: phone,
      cellphoneNumber: cellPhone,
      email: userInformation.email,
      rfc: userInformation.rfc,
      curp: userInformation.curp,
      personlDataFill: true,
    };

    await this.localStorageService.setLocalStorageItem(
      "userCapturedInformation",
      userCapturedInformation
    );
    this.props.onInvitedRedirectRegister();
  };

  goToChangePasswordScreen = () =>
    this.setState({ changePasswordScreen: !this.state.changePasswordScreen });

  sendUserDocSupps = async (data, callBack) => {
    this.setState({ isLoadingUserDocSupp: true }, async () => {
      let token = this.localStorageService.getLocalStorageItem("token").idToken;

      let result = await this.userDocSuppService.sendUserDocSupps(token, data);
      let { statusCode } = result;
      if (statusCode === 200) {
        this.setState(
          { isLoadingUserDocSupp: false, errorUserDocSupp: null },
          () => {
            this.setState({ saveImagesSuccess: true }, () =>
              setTimeout(() => {
                callBack();
                this.setState({
                  saveImagesSuccess: false,
                });
              }, 1500)
            );
            this.getUserDocSupps();
          }
        );
      } else {
        this.setState(
          { isLoadingUserDocSupp: false, errorUserDocSupp: true },
          () =>
            setTimeout(() => this.setState({ errorUserDocSupp: null }), 1500)
        );
      }
    });
  };
  changeUserDocSupps = async (data, callBack) => {
    this.setState({ isLoadingUserDocSupp: true }, async () => {
      let token = this.localStorageService.getLocalStorageItem("token").idToken;

      let result = await this.userDocSuppService.changeUserDocSupps(
        token,
        data
      );
      let { statusCode, message } = result;
      if (statusCode === 200) {
        this.setState(
          {
            isLoadingUserDocSupp: false,
            errorUserDocSupp: null,
            saveImagesSuccess: true,
          },
          () => {
            setTimeout(() => {
              callBack();
              this.setState({
                saveImagesSuccess: false,
              });
            }, 1500);
            this.getUserDocSupps();
          }
        );
      } else {
        let ms = "ocurrió un error intente más tarde";
        if (message) ms = message;

        this.setState(
          { isLoadingUserDocSupp: false, errorUserDocSupp: ms },
          () =>
            setTimeout(() => this.setState({ errorUserDocSupp: null }), 1500)
        );
      }
    });
  };

  /**
   * @author Adrian Montemayor
   * @description Error si no encuentra imagenes.
   * @date 21-20-21
   * @memberof SignatureCredetialForm
   */
  toggleErrorUserDocRequesting = (value) => {
    this.setState(
      {
        errorWarningDoc: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ errorWarningDoc: null });
        }, 3000);
      }
    );
  };

  getUserDocSupps = async () => {
    try {
      let token = this.localStorageService.getLocalStorageItem("token").idToken;

      let result = await this.userDocSuppService.getUserDocSupps(token);
      if (result) {
        let { autographySignImg, ineFrontImg, ineBackImg } = result;
        this.setState({
          signatureImg: "data:image/png;base64," + autographySignImg,
          ineFrontImg: "data:image/png;base64," + ineFrontImg,
          ineBackImg: "data:image/png;base64," + ineBackImg,
        });
      }
    } catch (error) { }
  };

  changeSignatureUserStates = (params = {}) => {
    let data = {};
    if (params.isLoadingUserDocSupp)
      data.isLoadingUserDocSupp = params.isLoadingUserDocSupp;
    if (params.errorUserDocSupp)
      data.errorUserDocSupp = params.errorUserDocSupp;
    if (params.signatureImg) data.signatureImg = params.signatureImg;
    if (params.ineFrontImg) data.ineFrontImg = params.ineFrontImg;
    if (params.ineBackImg) data.ineBackImg = params.ineBackImg;
    this.setState(data);
  };

  onErrorTimeStamp = async () => {
    this.setState({ message: `${this.props.t('signatureRequestDetailAction2.errorStampTimeFails')}` })
    this.toggleErrorRequesting(true)
    return false
  }

  render() {
    if (this.state.changePasswordScreen) {
      return (
        <div style={{ marginLeft: "15px" }}>
          <div className="globalContainerSignatureStyles">
            <ChangePasswordAction
              goToChangePasswordScreen={this.goToChangePasswordScreen}
            />
          </div>
        </div>
      );
    }

    return (
      <ProfileView
        {...this.state}
        validator={this.validator}
        validateInput={ValidateInputPure}
        handleEditProfile={this.handleEditProfile}
        toggleDialogProfile={this.toggleDialogProfile}
        onDeleteDataProfile={this.onDeleteDataProfile}
        goToChangePasswordScreen={this.goToChangePasswordScreen}
        notification={this.notification}
        onCloseOpenModal={this.onCloseOpenModal}
        handleChangeGeneral={this.handleChangeGeneral}
        toggleDialogUpdateUserAddress={this.toggleDialogUpdateUserAddress}
        onSubmitUpdateUserAddress={this.onSubmitUpdateUserAddress}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        handleImage={this.handleImage}
        onInvitedRedirectRegister={this.onInvitedExistRedirectRegister}
        downloadLoading={this.state.downloadLoading}
        downloadError={this.state.downloadError}
        sendUserDocSupps={this.sendUserDocSupps}
        changeUserDocSupps={this.changeUserDocSupps}
        toggleErrorUserDocRequesting={this.toggleErrorUserDocRequesting}
        changeSignatureUserStates={this.changeSignatureUserStates}
        fetchDowloadSignatures={this.fetchDowloadSignatures}
        onErrorTimeStamp={this.onErrorTimeStamp}

        handleChangeCellPhone={this.handleChangeCellPhone}
        handleChangePhone={this.handleChangePhone}
      >
        {/* {({ setVisibleSignatureReliable }) => (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button
              style={{ margin: '6px 10px' }}
              className="button-download-signature"
              onClick={
                () => !this.state.downloadLoading && this.setState({ downloadLoading: true }, () => this.fetchDowloadSignatures({ setVisibleSignatureReliable }))
              } >
              {'Descargar firma'}
            </button>
          </div>

        )} */}
      </ProfileView>
    );
  }
}

function ProfileActionContainer(props) {
  const { t } = useTranslation();
  const { setShowError } = useContext(Context);
  return <ProfileAction {...props} t={t} setShowError={setShowError} />;
}

export { ProfileActionContainer as default };
